<template>
  <main class="insertToken">
    <div class="insertToken__content">
      <InsertTokenInstructions :contactType="contactType" />
      <form v-on:submit.prevent>
        <VToken
          :retrievedValue="tokenValue"
          :isDisabled="isTokenDisabled"
          :isInvalid.sync="isTokenInvalid"
          @tokenHasCompleted="changeTokenInput"
          :errorMessage="errorMessage"
        />
        <VInnerSpinner v-if="isLoading" />
        <InsertTokenActions v-else :isDisabled="isTokenDisabled" @resendToken="resendToken" />
      </form>
    </div>
  </main>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import dataLayerPushAdmission from '@/utils/mixins/dataLayerPushAdmission';
import VInnerSpinner from '@/components/commons/VInnerSpinner.vue';
import VToken from '@/components/commons/VToken/VToken.vue';
import InsertTokenActions from '@/views/validationPatient/insertToken/partials/InsertTokenActions.partial.vue';
import InsertTokenInstructions from '@/views/validationPatient/insertToken/partials/InsertTokenInstructions.partial.vue';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'InsertToken',
  components: {
    VInnerSpinner,
    VToken,
    InsertTokenActions,
    InsertTokenInstructions,
  },
  mixins: [dataLayerPushAdmission, dataLayersMixin],

  data() {
    return {
      tokenValue: null,
      token: '',
      tokenStatus: '',
      isTokenDisabled: false,
      isTokenInvalid: false,
      isLoading: false,
    };
  },

  computed: {
    ...mapState({
      admissionStatus: ({ currentAdmission }) => currentAdmission.data.status,
      admissionId: ({ currentAdmission }) => currentAdmission.data.id,
      contactType: ({ validation }) => validation.data.chosenContactType,
      cpfSearched: ({ cpfSearched }) => cpfSearched.data.cpf,
      selectedUnit: ({ brandUnit }) => brandUnit.data.selectedUnit,
      errorMessage: ({ validation }) => validation.data.message,
    }),

    ...mapGetters(['isMobileService', 'getBrandUnitIdVariables', 'haveScheduledExams']),

    correctNextRedirectRouter() {
      return this.isMobileService
        ? 'irregular_phone_number_mobile_service'
        : 'irregular_phone_number';
    },
  },
  created() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Insira o código de validação',
    });
  },

  methods: {
    ...mapActions(['mdmConfirmationToken', 'getAdmissionById', 'sendValidationToken']),

    ...mapMutations(['enableLoader']),

    async changeTokenInput(value) {
      this.token = value;

      if (this.token.length === 6) {
        await this.validateToken();
      }
    },

    toggleInnerLoading(loadingValue) {
      if (this.isLoading) {
        setTimeout(() => {
          this.toggleDisabledAndLoadingStatus(loadingValue);
        }, 750);
      } else {
        return this.toggleDisabledAndLoadingStatus(loadingValue);
      }
    },

    toggleDisabledAndLoadingStatus(loadingAndDisabledValue) {
      this.isTokenDisabled = loadingAndDisabledValue || !this.isTokenDisabled;
      this.isLoading = loadingAndDisabledValue || !this.isLoading;
    },

    async validateToken() {
      this.toggleInnerLoading();

      const isTokenValid = await this.mdmConfirmationToken(this.token);

      if (isTokenValid) {
        await this.startValidTokenFlow();
      } else {
        this.isTokenInvalid = true;

        this.mostCommonPagesAnalytics({
          eventType: 'funnel_step',
          currentStep: 'Código inválido',
        });
        this.toggleInnerLoading();
      }
    },

    async startValidTokenFlow() {
      if (this.admissionStatus !== 'CHECK_IN_WAITING') {
        await this.getAdmissionById();
      }

      // this.dataLayerPushAdmission('isEligible');

      this.toggleInnerLoading();

      this.goNextStep('register_patient');
    },

    async resendToken() {
      this.toggleInnerLoading();
      await this.sendValidationToken();
      this.toggleInnerLoading();
    },

    async handleTokenSuccess(response) {
      if (this.token.length === 6 && response) {
        await this.validateToken();
      }
      return response;
    },
    async handleError(response) {
      return response;
    },
  },
};
</script>

<style lang="scss">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}

.insertToken {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  width: 100%;

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;

    @media (min-width: 321px) {
      font-size: var(--font-size-3);
      padding: 15px;
    }
  }

  .v-innerSpinner {
    padding: 32px 0;
  }
}
</style>
